import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import { NavigationService } from 'src/app/services/navigation.service';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { FormControl } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['header.component.scss'],
	standalone: false,
})
export class HeaderComponent implements OnInit {
	selectedTypeValue: PreorderType = PreorderType.TAKE_AWAY;
	@Input() allowedPreorderTypes: PreorderType[];
	@Input() customer: Customer;
	@Output() selectType = new EventEmitter<PreorderType>();
	@Output() back = new EventEmitter<void>();
	@Output() searchValue = new EventEmitter<string>();
	preorderTypes = [PreorderType.TAKE_AWAY, PreorderType.DELIVERY];
	public isOpen = false;
	searchControl = new FormControl('');
	version = environment.version;

	constructor(
		private popover: PopoverController,
		public translate: TranslateService,
		private navService: NavigationService,
		private cdr: ChangeDetectorRef
	) {}

	@Input() set selectedType(value: PreorderType) {
		if (value) {
			this.selectedTypeValue = value;
			this.cdr.detectChanges();
		}
	}

	ngOnInit() {
		this.searchControl.valueChanges.subscribe(v => {
			console.log(v);
			this.searchValue.emit(v);
		});
	}

	goBack() {
		this.back.emit();
	}

	onSelectType(type: PreorderType) {
		this.selectType.emit(type);
	}
}
